import dayjs from 'dayjs';
import {TSlot} from '../../../../../redux/timetable/timetable.type';
import {getStartOfDay} from '../../../../../library/dates';

export const formatSlotTime = (timeStart: number) => dayjs.unix(timeStart).format('HH:mm');

// Keep only slots that belong to the given day. Shared by the lecture and
// break popups so both lists show the hours for the relevant date only.
// When no day is provided, all slots are returned unfiltered.
export const filterSlotsByDay = (slots: TSlot[], dayTimestamp?: number): TSlot[] =>
    slots.filter(s =>
        dayTimestamp == null
            ? true
            : getStartOfDay(s.timeStart) === getStartOfDay(dayTimestamp));
